// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React from 'react'
import { node, oneOfType, string } from 'prop-types'
import { InfoItemWrapper } from './styles'

const InfoItem = ({ id, label, value }) => (
  <InfoItemWrapper>
    <span id={`${id}-label`}>{label}</span>
    <span id={id}>{value}</span>
  </InfoItemWrapper>
)

InfoItem.propTypes = {
  id: string.isRequired,
  label: oneOfType([
    node.isRequired,
    string.isRequired,
  ]),
  value: oneOfType([
    node.isRequired,
    string.isRequired,
  ]),
}

export default InfoItem
